import { ScreenHeader } from '$tablet-app/src/app/components/ScreenHeader';
import { ScreenTitle } from '$tablet-app/src/app/components/ScreenTitle';
import { useChecklistsInfoVideo } from '$tablet-app/src/app/videos/hooks/info_video_hooks';
import { spacing } from '@akin-home/theme';
import React, { PropsWithChildren, useMemo } from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';

const ChecklistScreenHeader = (props: PropsWithChildren) => {
  const { data } = useChecklistsInfoVideo();

  const source = useMemo(() => {
    return data?.value ? { drive_id: data.value } : undefined;
  }, [data]);

  const { width } = useWindowDimensions();
  const isSmallScreen = width < 755;

  const styles = isSmallScreen ? smallStyles : largeStyles;

  return (
    <ScreenHeader style={styles.screenHeader}>
      <View style={styles.titleContainer}>
        <ScreenTitle source={source}>Tasks Lists</ScreenTitle>
      </View>

      {props.children ? (
        <View style={styles.childrenContainer}>{props.children}</View>
      ) : null}
    </ScreenHeader>
  );
};

export default ChecklistScreenHeader;

const smallStyles = StyleSheet.create({
  screenHeader: {
    flexDirection: 'column',
    alignItems: 'flex-start',

    // Default
    gap: spacing[3],
  },
  titleContainer: {
    // Default
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  childrenContainer: {
    width: '100%',

    // Default
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const largeStyles = StyleSheet.create({
  screenHeader: {
    flexDirection: 'row',
    alignItems: 'center',

    // Default
    gap: spacing[3],
  },
  titleContainer: {
    // Default
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  childrenContainer: {
    maxWidth: 600,

    // Default
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
